import { useGLTF } from "@react-three/drei"
import { useEffect } from "react";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import OptimizedFireflySwarm from "../components/sceneComponents/FireflySwarm";
import { fireFlyConfigs2D } from "../model_data/lights";

const Landscape2D = () => {
    const landscape2D = useGLTF('./low_poly_environment_2dPortfolio.glb', true, false, (loader) => {
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.5/');
        dracoLoader.setDecoderConfig({ type: 'js' });
        loader.setDRACOLoader(dracoLoader);
    });

    useEffect(() => {
        landscape2D.scene.traverse((child) => {
            // Only set shadow properties on meshes
            if (child.isMesh) {
                child.receiveShadow = true;
                child.castShadow = true;
                
                if (child.material) {
                    child.material.needsUpdate = true;
                }
            }
        })
    }, [landscape2D]);

    return (
        <>
            <primitive 
                object={landscape2D.scene} 
                position={[-14, -8, -42]} 
                scale={[1, 1, 1]}
                rotation-y={Math.PI / 2}
            />

            <OptimizedFireflySwarm fireflyConfigs={fireFlyConfigs2D}/>
        </>
    )
}

export default Landscape2D;